"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KycQuestionTypes = exports.KycStatuses = void 0;
var KycStatuses;
(function (KycStatuses) {
    KycStatuses["LOADING_FIRST_QUESTION"] = "LOADING_FIRST_QUESTION";
    KycStatuses["FIRST_QUESTION_LOADED"] = "FIRST_QUESTION_LOADED";
    KycStatuses["LOADING_QUESTION_STATUS"] = "LOADING_QUESTION";
    KycStatuses["QUESTION_LOADED_STATUS"] = "QUESTION_LOADED";
    KycStatuses["LOADING_QUESTION_ERROR_STATUS"] = "LOADING_QUESTION_ERROR";
    KycStatuses["QUESTION_ERROR"] = "QUESTION_ERROR";
    KycStatuses["LOADING_SUBMIT_STATUS"] = "LOADING_SUBMIT";
    KycStatuses["FINISH_STATUS"] = "FINISH";
    KycStatuses["SUCCESS_STATUS"] = "SUCCESS";
    KycStatuses["ERROR_STATUS"] = "ERROR";
})(KycStatuses = exports.KycStatuses || (exports.KycStatuses = {}));
var KycQuestionTypes;
(function (KycQuestionTypes) {
    KycQuestionTypes["INPUT"] = "input";
    KycQuestionTypes["RADIOBUTTON"] = "radiobutton";
    KycQuestionTypes["SELECT"] = "select";
    KycQuestionTypes["CHECKBOX"] = "checkbox";
})(KycQuestionTypes = exports.KycQuestionTypes || (exports.KycQuestionTypes = {}));
//# sourceMappingURL=index.js.map